import CloseIcon from "@/assets/icons/close.svg";
import { cx } from "@/utils";
import * as Toast from "@radix-ui/react-toast";

import { MessageInstance } from "./MessageContext";

import styles from "./Messages.module.css";

export type MessageProps = Omit<MessageInstance, "id"> & {
  open?: boolean;
  onOpenChange(open: boolean): void;
};

const Message = ({
  title,
  message,
  type,
  action,
  actionLabel,
  open,
  onOpenChange,
  testId,
}: MessageProps) => {
  return (
    <Toast.Root
      data-testid={testId || `${type || "info"}-message`}
      className={cx(styles.message, {
        [styles.success]: type === "success",
        [styles.danger]: type === "danger",
        [styles.warning]: type === "warning",
      })}
      open={open}
      onOpenChange={onOpenChange}
    >
      <div className={styles.content}>
        {title && <Toast.Title className={styles.title}>{title}</Toast.Title>}
        {message && (
          <Toast.Description
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
      </div>
      {action && actionLabel ? (
        <Toast.Action
          className={styles.action}
          onClick={action}
          altText={actionLabel}
        >
          {actionLabel}
        </Toast.Action>
      ) : (
        <Toast.Close className={styles.close}>
          <CloseIcon height={16} />
        </Toast.Close>
      )}
    </Toast.Root>
  );
};

export default Message;
